import { makeAutoObservable, runInAction } from 'mobx'

export default class Table {
  getListAPI: any
  constructor(api: any) {
    makeAutoObservable(this)

    runInAction(() => {
      this.getListAPI = api
    })
  }

  list: any[] = []
  loading = false
  params: any = {}
  pagination = {
    current: 1,
    pageSize: 10,
    total: 0,
    size: 'default',
    showQuickJumper: false,
    showSizeChanger: false,
    onChange: (page: number, pageSize: number) => {
      const pagination = {
        current: page,
        pageSize
      }
      this.onChange(pagination)
    },
    showTotal: (total: number) => `共 ${total} 条`
  }

  getList = (current?: number, pageSize?: number): Promise<any> => {
    this.setLoading(true)
    let params = { ...this.params }
    params.curPage = current || this.pagination.current
    params.limit = pageSize || this.pagination.pageSize
    return this.getListAPI(params)
      .then((rs: any) => {
        this.setLoading()
        if (Number(rs.code) === 200 || Number(rs.code) === 0) {
          this.updateList(rs.data || rs.result)
          return rs
        } else {
          this.updateList([], 'error')
        }
      })
      .catch(() => {
        this.setLoading()
      })
  }

  setLoading = (value?: boolean): void => {
    this.loading = !!value
  }

  onChange = (pagination: any): Promise<any> => {
    this.pagination = {
      ...this.pagination,
      current: pagination.current,
      pageSize: pagination.pageSize
    }
    return this.getList(pagination.current, pagination.pageSize)
  }

  onListReset = (pageSize?: number): void => {
    this.list = []
    this.pagination.current = 1
    this.pagination.pageSize = pageSize || 10
    this.pagination.total = 0
  }

  updateList = (rs: any = {}, code = ''): void => {
    if (Array.isArray(rs)) {
      this.list =
        rs.map((item, index) => {
          item.rowKey = index + 1
          return item
        }) || []
    } else {
      let { data, records, list } = rs
      this.list = (data || records || list || []).map((item, index) => {
        item.rowKey = index + 1
        return item
      })
    }
    const { totalCount, pageSize, currPage } = rs
    this.pagination = {
      ...this.pagination,
      current: currPage,
      pageSize,
      total: Number(totalCount) || 0
    }
    if (code === 'error') {
      // message.error('获取数据失败')
      this.pagination.total = 0
      this.pagination.current = 1
    }
  }

  init = (params: any = {}): void => {
    for (let i in params) {
      let value = params[i]
      this.params[i] = value
    }
  }

  onParamsChange = (params: any = {}): void => {
    this.params = { ...this.params, ...params }
  }

  onParamsReset = (pageSize: number = 10): void => {
    this.params = {}
    this.pagination.current = 1
    this.pagination.pageSize = pageSize
  }

  onResetParams = (param: any): void => {
    this.params = { ...param }
  }
}
